export function Helper(target: any) {
    // console.log('register helper');
}
